import React, { useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DownloadSimple, Check, Copy } from '@phosphor-icons/react';
interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
}
interface ExportChatButtonProps {
  messages: Message[];
}
export function ExportChatButton({
  messages
}: ExportChatButtonProps) {
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  const formatChatForExport = () => {
    const header = `Mateo Cohen - AI Portfolio Chat Transcript
Generated: ${new Date().toLocaleString()}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

`;
    const chatContent = messages.map(msg => {
      const role = msg.role === 'user' ? 'Recruiter' : 'AI Assistant';
      const time = msg.timestamp.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
      return `[${time}] ${role}:\n${msg.content}\n`;
    }).join('\n');
    const footer = `
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
View full portfolio: https://mateocohen.com
Contact: [Your email/LinkedIn]`;
    return header + chatContent + footer;
  };
  const handleCopyToClipboard = async () => {
    const text = formatChatForExport();
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      setShowMenu(false);
    }, 2000);
  };
  const handleDownloadAsText = () => {
    const text = formatChatForExport();
    const blob = new Blob([text], {
      type: 'text/plain'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `mateo-cohen-chat-${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setShowMenu(false);
  };
  if (messages.length <= 1) return null; // Don't show if only welcome message
  return <div className="relative" data-id="element-225">
      <button onClick={() => setShowMenu(!showMenu)} className="p-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/20 hover:border-white/30 transition-all" title="Export conversation" data-id="element-226">
        <DownloadSimple className="w-4 h-4 text-white" data-id="element-227" />
      </button>

      <AnimatePresence data-id="element-228">
        {showMenu && <motion.div initial={{
        opacity: 0,
        y: -10,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -10,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="absolute bottom-full right-0 mb-2 w-56 bg-black/90 backdrop-blur-md border border-white/20 rounded-lg shadow-xl overflow-hidden" data-id="element-229">
            <div className="p-2" data-id="element-230">
              <p className="text-xs text-white/60 px-3 py-2" data-id="element-231">
                Export Conversation
              </p>

              <button onClick={handleCopyToClipboard} className="w-full flex items-center gap-3 px-3 py-2 rounded-md hover:bg-white/10 transition-colors text-left" data-id="element-232">
                {copied ? <>
                    <Check className="w-4 h-4 text-green-400" data-id="element-233" />
                    <span className="text-sm text-green-400" data-id="element-234">Copied!</span>
                  </> : <>
                    <Copy className="w-4 h-4 text-white/80" data-id="element-235" />
                    <span className="text-sm text-white" data-id="element-236">
                      Copy to Clipboard
                    </span>
                  </>}
              </button>

              <button onClick={handleDownloadAsText} className="w-full flex items-center gap-3 px-3 py-2 rounded-md hover:bg-white/10 transition-colors text-left" data-id="element-237">
                <DownloadSimple className="w-4 h-4 text-white/80" data-id="element-238" />
                <span className="text-sm text-white" data-id="element-239">Download as Text</span>
              </button>
            </div>

            <div className="px-3 py-2 bg-white/5 border-t border-white/10" data-id="element-240">
              <p className="text-xs text-white/50" data-id="element-241">
                Share this conversation with hiring managers
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}